import { Box, Button, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from "@mui/material"
import { BasketItem } from "../../app/models/basket"
import { Order } from "../../app/models/order"
import BasketTable from "../basket/BasketTable"
import { Link } from "react-router-dom";
import { currencyFormat } from "../../app/util/util"

interface Props {
    order: Order
    setSelectedOrder: (id: number) => void
}

export default function OrderDetailed({order, setSelectedOrder} : Props) {
    
    return (
        <>
            <Box display='flex' justifyContent='space-between'>
                <Typography sx={{p: 2}} gutterBottom variant='h4'>Order# {order.id} - {order.orderStatus}</Typography>
                <Button onClick={() => setSelectedOrder(0)} sx={{m: 2}} size='large' variant='contained'>Back to orders</Button>
            </Box>
            <BasketTable items={order.orderItems as BasketItem[]} isBasket={false} />
            <Grid container spacing={2}>
                {order.orderStatus !== 'Shipped' && <Grid item xs={6} />}
                {order.orderStatus === 'Shipped'&& 
                    <Grid item xs={6} >
                        
                        
                        <Typography variant="h5" sx={{p: 2}}>Tracking Info</Typography>
                            
                                <TableContainer component={Paper} variant={'outlined'}>
                                    <Table>
                                        <TableBody>
                                            
                                        
                                            <TableRow>
                                                <TableCell colSpan={2}>Courier service provider</TableCell>
                                                <TableCell align="right">{order.courierServiceProvider}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell colSpan={2}>Tracking number</TableCell>
                                                <TableCell align="right">{order.trackingNumber}</TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            
                    </Grid>
                }
                <Grid item xs={6}>
                <TableContainer component={Paper} variant={'outlined'}>
                <Table>
                    <TableBody>
                        <TableRow>
                            <TableCell colSpan={2}>Subtotal</TableCell>
                            <TableCell align="right">{currencyFormat(order.subtotal)}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={2}>Delivery fee*</TableCell>
                            <TableCell align="right">{currencyFormat(order.deliveryFee)} </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={2}>Total</TableCell>
                            <TableCell align="right">{currencyFormat(order.total)}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                <span style={{fontStyle: 'italic'}}>*Delivery fee is calculated later based on your address and shipping option. You can check our <Link to='/shipping'>shipping fee policy</Link>.</span><br/><br/>
                                <span style={{fontStyle: 'italic'}}>You can check our <Link to='/refund'>Refund policy and care</Link>.</span>
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
                </Grid>
            </Grid>
            
          </>
    )
}